import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetQuoteTemplate as GetQuoteTemplateQuery,
    GetQuoteTemplate_quoteTemplate as Quote,
} from 'nutshell-graphql-types';

import GET_QUOTE_TEMPLATE from '../queries/get-quote-template.graphql';

export const useGetQuoteTemplate = (): {
    quoteTemplate: Quote;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetQuoteTemplateQuery, Record<any, any>>(
        GET_QUOTE_TEMPLATE,
        {}
    );

    const {quoteTemplate} = makeDataDangerous(data);

    return {
        quoteTemplate,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
